function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.084 5.298c-.89 0-1.616-.627-1.616-1.398 0-.771.725-1.398 1.616-1.398.89 0 1.615.627 1.615 1.398a.734.734 0 001.469 0c0-1.345-1.003-2.477-2.35-2.784V.734a.734.734 0 00-1.468 0v.382C1.003 1.423 0 2.554 0 3.9c0 1.58 1.383 2.867 3.084 2.867.89 0 1.615.627 1.615 1.398 0 .77-.724 1.398-1.615 1.398-.89 0-1.616-.627-1.616-1.398a.734.734 0 00-1.468 0c0 1.345 1.003 2.477 2.35 2.784v.317a.734.734 0 001.468 0v-.317c1.347-.307 2.35-1.439 2.35-2.784 0-1.581-1.384-2.867-3.084-2.867z"
});

function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 12",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgDollar;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dollar.svg
// module id = 1303
// module chunks = 10